import { useEffect, useState } from "react";
import { FormModal } from "../../../CommonElements";
import AbsenForm from "../../Absen/components/AbsenForm";
import { getDateToday } from "../../../Utils/externalFunctions";
import { useStaf } from "../../../Context/StafContext";

const ModalAbsen = ({ isOpen, toggle, data, refreshStaff }) => {
  const stafAPI = useStaf();
  const today = getDateToday("original");
  const [isLoading, setIsLoading] = useState(true);
  const [staffData, setStaffData] = useState(null);

  const getCurrentDateParts = () => {
    const date = new Date();
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    return { day, month, year };
  };

  useEffect(() => {
    if (isOpen) {
      setIsLoading(true);
      const { day, month, year } = getCurrentDateParts();
      Promise.all([
        fetchAbsensiToday(day, month, year),
        fetchDetailAbsensiToday(day, month, year)
      ])
        .then(([absenData, detailData]) => {
          setStaffData({
            ...data,
            ...absenData,
            ...detailData
          });
          setIsLoading(false);
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          setIsLoading(false);
        });
    }
  }, [isOpen, data.id]);

  const fetchAbsensiToday = async (day, month, year) => {
    const currentMonth = `${year}-${month}`;
    try {
      const response = await stafAPI.getAbsensiByStafIdandDate(data.id, currentMonth);
      const today = `${year}-${month}-${day}`;
      const absensiToday = response.data.find((item) => item.tanggal.startsWith(today));
      return { absen: absensiToday || null };
    } catch (error) {
      console.error('Error fetching absensi:', error);
      return { absen: null };
    }
  };

  const fetchDetailAbsensiToday = async (day, month, year) => {
    const currentMonth = `${year}-${month}`;
    try {
      const response = await stafAPI.getAbsensiDetailByStafIdandDate(data.id, currentMonth);
      const today = `${year}-${month}-${day}`;
      const absensiToday = response.data.filter((item) =>
        item.date_created.startsWith(today)
      );

      const detailData = { datang: null, pulang: null };
      absensiToday.forEach((item) => {
        if (item.mode === 1) {
          detailData.datang = item;
        } else if (item.mode === 2) {
          detailData.pulang = item;
        }
      });
      return detailData;
    } catch (error) {
      console.error('Error fetching detail absensi:', error);
      return { datang: null, pulang: null };
    }
  };

  return (
    <FormModal title="Absen" isOpen={isOpen} toggle={toggle}>
      {!isLoading && staffData && (
        <AbsenForm
          resetState={refreshStaff}
          toggle={toggle}
          staf={staffData}
          dateFilter={today}
          create={!staffData.absen}
        />
      )}
    </FormModal>
  );
};

export default ModalAbsen;